import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { kebabCase } from 'lodash';
import { Stack } from '@hub/stack';
import { Box } from '@hub/box';
import { GIFT_CARDS } from '../../paths';
import { LinkSection } from './link-section';
import { CentreDetails } from './centre-details';
import * as paths from './paths';
import { trackUniversalFooterLinkClick } from './analytics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const customerSupport = {
  text: 'Customer Support',
  url: paths.CUSTOMER_SUPPORT
};
const covidInformation = {
  text: 'COVID information',
  url: paths.COVID_INFORMATION,
  newTab: true
};
const westfieldDirect = {
  heading: {
    text: 'Westfield Direct',
    url: paths.WESTFIELD_DIRECT
  },
  links: [{
    text: 'About Westfield Direct',
    url: paths.SHOP_ABOUT,
    newTab: true
  }, {
    text: 'Click & Collect',
    url: paths.SHOP_CLICK_COLLECT,
    newTab: true
  }, {
    text: 'Delivery',
    url: paths.SHOP_DELIVERY,
    newTab: true
  }, {
    text: 'Returns',
    url: paths.SHOP_RETURNS,
    newTab: true
  }, {
    text: 'Brands',
    url: paths.SHOP_BRANDS,
    newTab: false
  }, {
    text: 'Curated Collections',
    url: paths.PRODUCT_COLLECTIONS,
    newTab: false
  }, {
    text: 'Size guide',
    url: paths.SHOP_SIZE_GUIDE,
    newTab: false
  }, {
    text: 'Terms and Conditions',
    url: paths.TERMS_CONDITIONS_WESTFIELD_DIRECT,
    newTab: false
  }, {
    text: 'Direct Promotions',
    url: paths.DIRECT_PROMOTIONS,
    newTab: false
  }, {
    text: 'Privacy statement',
    url: paths.PRIVACY_POLICY_WESTFIELD_DIRECT,
    newTab: false
  }, {
    text: 'FAQs',
    url: paths.FAQS,
    newTab: true
  }]
};
const giftCards = {
  heading: {
    text: 'Westfield Gift Cards',
    url: GIFT_CARDS
  },
  links: [{
    text: 'Digital Gift Card',
    url: paths.GIFT_CARDS_DIGITAL_RETAIL
  }, {
    text: 'Gift Card',
    url: paths.GIFT_CARDS_PHYSICAL_RETAIL,
    newTab: true,
    links: [{
      text: 'Terms and Conditions',
      url: paths.TERMS_CONDITIONS,
      newTab: true
    }]
  }, {
    text: 'Corporate',
    url: paths.GIFT_CARDS_PHYSICAL_CORPORATE,
    newTab: true
  }]
};
const LeftColumnContainerFlexGrowDesktop = 3;
export const LeftColumnContainer = _ref => {
  let {
    centre,
    country,
    onFindACentre
  } = _ref;
  return /*#__PURE__*/_jsxs(Stack, {
    direction: ['column', 'column', 'column', 'row'],
    shouldWrapChildren: false,
    gap: ['spacing-xl', 'spacing-xl', 'spacing-xl', '0'],
    sx: {
      flexGrow: [1, 1, 1, LeftColumnContainerFlexGrowDesktop]
    },
    "data-id": "universal-footer_left-column-container_LeftColumnContainer_Stack",
    children: [/*#__PURE__*/_jsxs(Stack, {
      as: props => /*#__PURE__*/_jsx("nav", _objectSpread(_objectSpread({}, props), {}, {
        "aria-label": "Footer Links",
        "data-id": "universal-footer_left-column-container_LeftColumnContainer_nav"
      })),
      shouldWrapChildren: false,
      gap: "spacing-xl",
      sx: {
        flexGrow: 1,
        paddingRight: 'spacing-xl',
        marginRight: 'spacing-2xl'
      },
      "data-id": "universal-footer_left-column-container_LeftColumnContainer_Stack_Stack_1",
      children: [centre ? /*#__PURE__*/_jsx(CentreDetails, {
        centre: centre,
        onFindACentre: onFindACentre,
        "data-id": "universal-footer_left-column-container_LeftColumnContainer_CentreDetails"
      }) : onFindACentre && /*#__PURE__*/_jsx(LinkSection, {
        heading: {
          text: 'Visit a centre',
          onClick: onFindACentre
        },
        trackers: {
          clicked: trackUniversalFooterLinkClick
        },
        "data-id": "universal-footer_left-column-container_LeftColumnContainer_LinkSection"
      }), country === 'Australia' && /*#__PURE__*/_jsx(LinkSection, {
        heading: customerSupport,
        trackers: {
          clicked: trackUniversalFooterLinkClick
        },
        "aria-labelledby": kebabCase(customerSupport.text),
        "data-id": "universal-footer_left-column-container_LeftColumnContainer_LinkSection_5"
      }), /*#__PURE__*/_jsx(LinkSection, {
        heading: covidInformation,
        trackers: {
          clicked: trackUniversalFooterLinkClick
        },
        "aria-labelledby": kebabCase(covidInformation.text),
        "data-id": "universal-footer_left-column-container_LeftColumnContainer_Stack_LinkSection_6"
      })]
    }), country === 'Australia' && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Box, {
        as: "nav",
        "aria-labelledby": kebabCase(westfieldDirect.heading.text),
        sx: {
          flexGrow: 1
        },
        "data-id": "universal-footer_left-column-container_LeftColumnContainer_Box",
        children: /*#__PURE__*/_jsx(LinkSection, {
          heading: westfieldDirect.heading,
          links: westfieldDirect.links,
          trackers: {
            clicked: trackUniversalFooterLinkClick
          },
          "data-id": "universal-footer_left-column-container_LeftColumnContainer_Box_LinkSection"
        })
      }), /*#__PURE__*/_jsx(Box, {
        as: "nav",
        "aria-labelledby": kebabCase(giftCards.heading.text),
        sx: {
          flexGrow: 1
        },
        "data-id": "universal-footer_left-column-container_LeftColumnContainer_Box",
        children: /*#__PURE__*/_jsx(LinkSection, {
          heading: giftCards.heading,
          links: giftCards.links,
          trackers: {
            clicked: trackUniversalFooterLinkClick
          },
          "data-id": "universal-footer_left-column-container_LeftColumnContainer_Box_LinkSection"
        })
      })]
    })]
  });
};